/**
 * SVG path data for each care_growth_type.
 * Extracted from Lucide icons (v0.555.0), 24×24 viewBox.
 *
 * Icons with only <path> elements are used as-is.
 * Icons with <circle> elements have them converted to SVG arc paths:
 *   circle(cx, cy, r) → M(cx-r) cy a r r 0 1 0 (2r) 0 a r r 0 1 0 -(2r) 0
 *
 * Multiple subpaths are combined into a single string (space-separated M commands).
 */

export const GROWTH_TYPE_ICON_PATHS = {
  // Lucide "Shrub" — 3 paths
  shrub: 'M12 22v-5.172a2 2 0 0 0-.586-1.414L9.5 13.5 M14.5 14.5 12 17 M17 8.8A6 6 0 0 1 13.8 20H10A6.5 6.5 0 0 1 7 8a5 5 0 0 1 10 0z',

  // Lucide "Flower2" — 4 paths + circle(12,8,2) converted to arc
  perennial: 'M12 5a3 3 0 1 1 3 3m-3-3a3 3 0 1 0-3 3m3-3v1M9 8a3 3 0 1 0 3 3M9 8h1m5 0a3 3 0 1 1-3 3m3-3h-1m-2 3v-1 M10 8a2 2 0 1 0 4 0a2 2 0 1 0-4 0 M12 10v12 M12 22c4.2 0 7-1.667 7-5-4.2 0-7 1.667-7 5Z M12 22c-4.2 0-7-1.667-7-5 4.2 0 7 1.667 7 5Z',

  // Lucide "TreeDeciduous" — 2 paths
  tree: 'M8 19a4 4 0 0 1-2.24-7.32A3.5 3.5 0 0 1 9 6.03V6a3 3 0 1 1 6 0v.04a3.5 3.5 0 0 1 3.24 5.65A4 4 0 0 1 16 19Z M12 19v3',

  // Zimmerpflanze (Ficus, Dracaena, Yucca) — reuses TreeDeciduous bis eigenes Icon kommt
  houseplant: 'M8 19a4 4 0 0 1-2.24-7.32A3.5 3.5 0 0 1 9 6.03V6a3 3 0 1 1 6 0v.04a3.5 3.5 0 0 1 3.24 5.65A4 4 0 0 1 16 19Z M12 19v3',

  // Lucide "Sprout" — 3 paths
  annual: 'M14 9.536V7a4 4 0 0 1 4-4h1.5a.5.5 0 0 1 .5.5V5a4 4 0 0 1-4 4 4 4 0 0 0-4 4c0 2 1 3 1 5a5 5 0 0 1-1 3 M4 9a5 5 0 0 1 8 4 5 5 0 0 1-8-4 M5 21h14',

  // Lucide "Leaf" — 2 paths
  herb: 'M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8 0 5.5-4.78 10-10 10Z M2 21c0-3 1.85-5.36 5.08-6C9.5 14.52 12 13 13 12',

  // Lucide "CircleDot" — circle(12,12,10) + circle(12,12,1) converted to arcs
  bulb: 'M2 12a10 10 0 1 0 20 0a10 10 0 1 0-20 0 M11 12a1 1 0 1 0 2 0a1 1 0 1 0-2 0',

  // Lucide "Grape" — 1 path + 8 circles(r=3) converted to arcs
  vine: 'M22 5V2l-5.89 5.89 M13.6 15.89a3 3 0 1 0 6 0a3 3 0 1 0-6 0 M5.11 7.4a3 3 0 1 0 6 0a3 3 0 1 0-6 0 M9.35 11.65a3 3 0 1 0 6 0a3 3 0 1 0-6 0 M10.91 5.85a3 3 0 1 0 6 0a3 3 0 1 0-6 0 M15.15 10.09a3 3 0 1 0 6 0a3 3 0 1 0-6 0 M3.56 13.2a3 3 0 1 0 6 0a3 3 0 1 0-6 0 M7.8 17.44a3 3 0 1 0 6 0a3 3 0 1 0-6 0 M2 19a3 3 0 1 0 6 0a3 3 0 1 0-6 0',

  // Lucide "Carrot" — 3 paths (first path already contains multiple subpaths)
  vegetable: 'M2.27 21.7s9.87-3.5 12.73-6.36a4.5 4.5 0 0 0-6.36-6.37C5.77 11.84 2.27 21.7 2.27 21.7zM8.64 14l-2.05-2.04M15.34 15l-2.46-2.46 M22 9s-1.33-2-3.5-2C16.86 7 15 9 15 9s1.33 2 3.5 2S22 9 22 9z M15 2s-2 1.33-2 3.5S15 9 15 9s2-1.84 2-3.5C17 3.33 15 2 15 2z',

  // Lucide "Wheat" — 8 paths
  grass: 'M2 22 16 8 M3.47 12.53 5 11l1.53 1.53a3.5 3.5 0 0 1 0 4.94L5 19l-1.53-1.53a3.5 3.5 0 0 1 0-4.94Z M7.47 8.53 9 7l1.53 1.53a3.5 3.5 0 0 1 0 4.94L9 15l-1.53-1.53a3.5 3.5 0 0 1 0-4.94Z M11.47 4.53 13 3l1.53 1.53a3.5 3.5 0 0 1 0 4.94L13 11l-1.53-1.53a3.5 3.5 0 0 1 0-4.94Z M20 2h2v2a4 4 0 0 1-4 4h-2V6a4 4 0 0 1 4-4Z M11.47 17.47 13 19l-1.53 1.53a3.5 3.5 0 0 1-4.94 0L5 19l1.53-1.53a3.5 3.5 0 0 1 4.94 0Z M15.47 13.47 17 15l-1.53 1.53a3.5 3.5 0 0 1-4.94 0L9 15l1.53-1.53a3.5 3.5 0 0 1 4.94 0Z M19.47 9.47 21 11l-1.53 1.53a3.5 3.5 0 0 1-4.94 0L13 11l1.53-1.53a3.5 3.5 0 0 1 4.94 0Z',
};

/**
 * Get SVG path data for a given care_growth_type.
 * Falls back to Flower2 (perennial) for unknown or null types.
 * Note: "lawn" type is not platzierbar but returns a fallback if ever used.
 *
 * @param {string|null|undefined} growthType - growth_type enum value from plant.properties
 * @returns {string} Combined SVG path data string
 */
export function getIconPathForGrowthType(growthType) {
  return GROWTH_TYPE_ICON_PATHS[growthType] ?? GROWTH_TYPE_ICON_PATHS.perennial;
}
